import f from "axios";
import { useEventListener as E, useSyncedRef as h, useIntersectionObserver as g, useThrottledCallback as T } from "@react-hookz/web";
import { useState as u, useEffect as v, useCallback as S } from "react";
import { g as w } from "./index-CnymUPx7.mjs";
const C = (s) => ({
  createUser: (t) => f.post(`${s}/email/login`, {
    ...t,
    create: 1,
    flow: 1,
    newsletterSubscribe: 1
  }, {
    headers: {
      "Content-Type": "application/json"
    },
    withCredentials: !0
  })
});
function G() {
  const [s, r] = u();
  return E(w(), "blur", () => {
    var t;
    typeof window > "u" || r((t = document) === null || t === void 0 ? void 0 : t.activeElement);
  }), {
    activeElement: s
  };
}
const x = (s) => {
  const {
    ga4TrackingHandler: r,
    getGa4Event: t,
    options: e
  } = s, o = h(t), [a, d] = u(null), [p, l] = u(!1), c = e != null && e.shouldSendOnce ? !p : !0, n = g(c && o.current ? a : null, {
    threshold: e == null ? void 0 : e.intersectionThreshold
  }), m = T((i) => {
    e != null && e.isSendGA4Tracking && i && r && r(i), l(!0);
  }, [r, l], e != null && e.shouldThrottle ? 300 : 0, !0);
  return v(() => {
    !c || !(n != null && n.isIntersecting) || !o.current || m(o.current ? o.current() : null);
  }, [c, n == null ? void 0 : n.isIntersecting, m, o]), v(() => {
    l(!1);
  }, [a]), {
    captureTrackImpressionEventTargetElement: S((i) => {
      d(i);
    }, [d]),
    intersection: n
  };
};
export {
  G as a,
  x as b,
  C as u
};
//# sourceMappingURL=tracking-impression-event-BSYv6VZE.mjs.map
